function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 3,
  fill: "#005646"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.923 4.337a1.989 1.989 0 012.293.383c.637.637.797 1.56.414 2.324l3.504 3.504c.095.095.095.223 0 .318l-.637.637c-.096.096-.223.096-.35-.032L6.642 7.968a1.989 1.989 0 01-2.293-.382 1.989 1.989 0 01-.382-2.293L5.146 6.47l.956-.955-1.179-1.179z",
  stroke: "#fff"
});

function SvgRepair2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgRepair2;